import React, { useRef, useState, useEffect } from "react";
import { Prompt } from "react-router-dom";
import { FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import PasswordGenerator from "../components/PasswordGenerator";
import PasswordStrengthIndicator from "../components/PasswordStrengthIndicator";
import config from "../config";
import "./NewNote.css";
import { post } from 'aws-amplify/api';
import { s3Upload } from "../libs/awsLib";
import utils from "../utils";

export default function NewLoginDetail(props) {
  const file = useRef(null);
  const [websiteName, setWebsiteName] = useState("");
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showGenerator, setShowGenerator] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  // Track if any field has been modified
  useEffect(() => {
    const hasChanges = 
      websiteName.length > 0 ||
      loginId.length > 0 ||
      password.length > 0 ||
      websiteUrl.length > 0 ||
      (file.current && file.current.size > 0);
    
    setHasUnsavedChanges(hasChanges);
  }, [websiteName, loginId, password, websiteUrl]);

  function validateForm() {
    return websiteName.length > 0;
  }

  function handleFileChange(event) {
    file.current = event.target.files[0];
  }

  async function handleSubmit(event) {
    event.preventDefault();
  
    if (file.current && file.current.size > config.MAX_ATTACHMENT_SIZE) {
      alert(
        `Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE /
          1000000} MB.`
      );
      return;
    }
  
    setIsLoading(true);
  
    try {
      const attachment = file.current
        ? await s3Upload(file.current)
        : null;

      const data = {
        websiteName: utils.encrypt(websiteName),
        loginId: utils.encrypt(loginId),
        password: utils.encrypt(password),
        websiteUrl: utils.encrypt(websiteUrl)
      }
  
      await createLoginDetail({ data, attachment });
      setHasUnsavedChanges(false);
      props.history.push("/");
    } catch (e) {
      alert(e);
      setIsLoading(false);
    }
  }
  
  async function createLoginDetail(loginDetail) {
    const restOperation = post({
      apiName: "logindetails",
      path: "/logindetails",
      options: {
        body: loginDetail.data
      }
    });
    await restOperation.response;
  }

  return (
    <div className="NewNote">
      <Prompt
        when={hasUnsavedChanges}
        message="You have unsaved changes. Are you sure you want to leave?"
      />
      <form onSubmit={handleSubmit}>
        <FormGroup controlId="content">
            <ControlLabel>Website name</ControlLabel>
            <FormControl
              value={websiteName}
              type="text"
              onChange={e => setWebsiteName(e.target.value)}
            />
            </FormGroup>
            <FormGroup controlId="loginId">
            <ControlLabel>Login id</ControlLabel>
            <FormControl
              value={loginId}
              type="text"
              onChange={e => setLoginId(e.target.value)}
            />
            </FormGroup>
            <FormGroup controlId="password">
            <ControlLabel>Password</ControlLabel>
            <FormControl
              value={password}
              type="password"
              onChange={e => setPassword(e.target.value)}
            />
            <PasswordStrengthIndicator password={password} />
            <Button 
              bsStyle="link" 
              onClick={() => setShowGenerator(!showGenerator)}
              style={{ padding: "5px 0", marginTop: "5px" }}
            >
              {showGenerator ? "Hide" : "Show"} Password Generator
            </Button>
            {showGenerator && (
              <PasswordGenerator 
                onPasswordGenerated={(pwd) => {
                  setPassword(pwd);
                  setShowGenerator(false);
                }}
              />
            )}
        </FormGroup>
        <FormGroup controlId="url">
            <ControlLabel>Url</ControlLabel>
            <FormControl
              value={websiteUrl}
              type="text"
              onChange={e => setWebsiteUrl(e.target.value)}
            />
        </FormGroup>
        <FormGroup controlId="file">
          <ControlLabel>Attachment</ControlLabel>
          <FormControl onChange={handleFileChange} type="file" />
        </FormGroup>
        <LoaderButton
          block
          type="submit"
          bsSize="large"
          bsStyle="primary"
          isLoading={isLoading}
          disabled={!validateForm()}
        >
          Create
        </LoaderButton>
      </form>
    </div>
  );
}